import HttpResponse from "../../../utils/http/http.response";
import railyApiService from "../raily-api.service";
import OperatorAddRequest, {
  OperatorAddRequestBody,
} from "./add/operator-add-request";
import operatorAddRequestFactory from "./add/operator-add-request.factory";

const operatorApiService = () => {
  const add = (
    request: OperatorAddRequest,
    abortSignal: AbortSignal,
  ): Promise<HttpResponse> => {
    const url = `/operators`;

    const body: OperatorAddRequestBody =
      operatorAddRequestFactory.createBody(request);

    return railyApiService().post({
      url,
      abortSignal,
      body,
    });
  };

  return { add };
};

export default operatorApiService;
